import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { addTranslation, IntlProps } from '../../../../../decorators/addTranslation';

import { SinglePayoutContext } from '../context';

class PayoutStepper extends PureComponent<IntlProps> {
  render() {
    const { getTranslate } = this.props;
    const { activeStep } = this.context;

    return (
      <div className="stepper-wrapper">
        <div className={
          classNames('stepper-item', { 'completed': activeStep >= 1 })
        }>
          <div className="step-counter"></div>
          <div className="step-name">{getTranslate('payouts.request.Step1')}</div>
        </div>
        <div className={
          classNames('stepper-item', { 'completed': activeStep > 1 })
        }>
          <div className="step-counter"></div>
          <div className="step-name">{getTranslate('payouts.request.Step2')}</div>
        </div>
      </div>
    );
  }
}

PayoutStepper.contextType = SinglePayoutContext;

export default addTranslation(PayoutStepper);